import { $http } from 'src/services/http'
import { ThresholdEnum } from 'src/content/Threshold/ThresholdEnum'

const CLIENT_THRESHOLDS = '/clients/threshold'
const MANUFACTURE_THRESHOLDS = '/pos/manufacture/thresholds'

class ThresholdsService {
  getThresholds = async (thresholdType: number, posId?: number) => {
    const response = await $http.get(
      thresholdType === ThresholdEnum.CLIENTS
        ? CLIENT_THRESHOLDS
        : MANUFACTURE_THRESHOLDS,
      { params: { posId } },
    )
    return response.data
  }

  updateThresholds = async (
    thresholdType: number,
    thresholds: IThresholdRequest[],
    posId?: number,
  ) => {
    const response = await $http.put(
      thresholdType === ThresholdEnum.CLIENTS
        ? CLIENT_THRESHOLDS
        : MANUFACTURE_THRESHOLDS,
      thresholds,
      { params: { posId } },
    )
    return response.data
  }
}

export default new ThresholdsService()
